<ng-container *ngrxLet="timer$ as timer">

  <div class="timer-container">
    <span class="time">{{ timer | date:'HH:mm' }}</span>
    <span class="date">{{ timer | date:'EEEE' }}</span>
    <span class="date">{{ timer | date:'dd/MM/yyyy' }}</span>
  </div>

</ng-container>